import { render } from "./mobile_menu_text.vue?vue&type=template&id=9a5fc834&scoped=true"
import script from "./mobile_menu_text.vue?vue&type=script&lang=js"
export * from "./mobile_menu_text.vue?vue&type=script&lang=js"

import "./mobile_menu_text.vue?vue&type=style&index=0&id=9a5fc834&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5fc834"]])

export default __exports__